<template>
    <div class="content">
        <a-spin v-if="isLoadingTrucks" tip="Loading..."/>
        <div v-else>
            <Row>
                <Col span="24">
                    <a-select mode="multiple" v-model="selectedTrucks" style="width: 100%" @change="handleChange" placeholder="Please select trucks">
                        <a-select-option v-for="truck in trucks" :key="truck.id" :value="truck.id">{{truck.plate}}</a-select-option>
                    </a-select>
                </Col>
            </Row>
            <br>
            <Row>
                <Col span="24">
                    <a-list
                            :grid="{ gutter: 24, column: 3 }"
                            :dataSource="selectedTrucks"
                    >
                        <a-list-item slot="renderItem" slot-scope="item, index">
                            <truck-map :truck-id="item">Card content</truck-map>
                        </a-list-item>
                    </a-list>
                </Col>
            </Row>
        </div>
    </div>
</template>
<script>
    import TruckMap from '../cards/TruckMapCard';

    export default {
        components: {
            TruckMap,
        },
        data () {
            return {
                trucks: [],
                selectedTrucks: [],
                isLoadingTrucks: false,
            }
        },
        methods: {
            handleChange(value) {
                console.log(`selected ${value}`);
            },
            loadTrucks () {
                this.isLoadingTrucks = true;
                api.get('/carrier/gps/trucks?type=minute')
                    .then((response) => {
                        let trucks = response.data.data;
                        trucks = trucks.map(function(truck){
                            return {
                                id: truck.id,
                                plate: truck.plate,
                            }
                        });
                        this.trucks = trucks;
                    }).catch((error) => {
                        console.log(error);
                        this.$message.error('Sorry, failed to load your trucks.');
                    }).then(() => {
                        this.isLoadingTrucks = false;
                });
            },
        },
        mounted() {
            this.loadTrucks();
        },
        computed: {
        }
    }
</script>

<style scoped>
    .content {
        text-align: center;
    }
</style>